import { motion } from 'framer-motion';
import styled from 'styled-components';

export const FadeInOut = styled(motion.div)``;
